import { t } from '@gem/modules/i18n';
import {
  ONE_AVERAGE_MONTH,
  ONE_AVERAGE_YEAR,
  ONE_DAY,
  ONE_HOUR,
  ONE_MINUTE,
} from '@gem/services/date-service';

import { TChatAutoCleanupPeriodUnit } from './ChatAutoCleanupSettings.types';

export function getTtlPeriodUnit(period: number): TChatAutoCleanupPeriodUnit {
  if (period >= ONE_AVERAGE_YEAR) {
    return 'year';
  }

  if (period > ONE_AVERAGE_MONTH) {
    return 'month';
  }

  if (period > ONE_DAY) {
    return 'day';
  }

  if (period >= 24 * ONE_HOUR) {
    return 'hour';
  }

  return 'minute';
}

export function getTtlPeriodInUnit(ttlPeriodMs: number, unit: TChatAutoCleanupPeriodUnit): number {
  switch (unit) {
    case 'minute':
      return ttlPeriodMs / ONE_MINUTE;
    case 'hour':
      return ttlPeriodMs / ONE_HOUR;
    case 'day':
      return ttlPeriodMs / ONE_DAY;
    case 'month':
      return ttlPeriodMs / ONE_AVERAGE_MONTH;
    case 'year':
      return ttlPeriodMs / ONE_AVERAGE_YEAR;
    default:
      return ttlPeriodMs;
  }
}

function getTtlPeriodTitleLocaleKey(unit: TChatAutoCleanupPeriodUnit): string {
  switch (unit) {
    case 'minute':
      return 'chat_auto_cleanup_period_minute';
    case 'hour':
      return 'chat_auto_cleanup_period_hour';
    case 'day':
      return 'chat_auto_cleanup_period_day';
    case 'month':
      return 'chat_auto_cleanup_period_month';
    case 'year':
      return 'chat_auto_cleanup_period_year';
    default:
      return '';
  }
}

export function getTtlPeriodText(ttlPeriodMs: number): string {
  if (!ttlPeriodMs) {
    return t('chat_auto_cleanup_off');
  }
  const unit = getTtlPeriodUnit(ttlPeriodMs);
  const periodInUnit = getTtlPeriodInUnit(ttlPeriodMs, unit);
  const localeKey = getTtlPeriodTitleLocaleKey(unit);

  // Чтобы показывать только один знак после запятой, если не целое число. И если целое или округляется так, что
  // после запятой 0 десятых, а только сотые, тысячные и тд - то будет просто целое без запятой
  const roundedCount = Math.round(periodInUnit * 10) / 10;

  return t(localeKey, { count: Math.trunc(periodInUnit), 0: roundedCount });
}
